import data from '../../data/pageData.json';
import {
  enrollPayerAuth,
  fetchCaptureContext,
  getStaticRequestResponse,
  setupPayerAuth,
  validatePaAuth
} from '../../services/3ds-api-service';
import loadMicroform from '../../utils/microform';
import { ActionTypes } from '../constants/action-types';

export const setDefaultBanner = () => {
  return {
    type: ActionTypes.UPDATE_BANNER,
    payload: data.microformWithPayerAuth,
    demoToolType: 'microformWithPayerAuth'
  };
};

export const displayStartOver = () => {
  return {
    type: ActionTypes.TOGGLE_START_OVER_CALLOUT,
    payload: true
  };
};

export const setMicroformOnlyBanner = () => {
  return {
    type: ActionTypes.UPDATE_BANNER,
    payload: data.microformOnly,
    demoToolType: 'microformOnly'
  };
};

export const switchButton = (buttonType) => {
  return {
    type: ActionTypes.UPDATE_CONSOLE_LOG_RUN_SEQUENCES,
    payload: buttonType
  };
};

export const updateButtonStatus = (stageNumber) => {
  return {
    type: ActionTypes.UPDATE_RUN_SEQUENCE,
    payload: stageNumber
  };
};

export const toggleConsoleCard = (stageNumber) => {
  return {
    type: ActionTypes.TOGGLE_CONSOLE_LOG,
    payload: stageNumber
  };
};

export const captureContext = () => async () => {
  fetchCaptureContext();
};

export const loadStaticRequestResponse =
  (stage, requestResponseXFPath, xfRootPath, challengeCardChoosed, demoToolType) => async () => {
    getStaticRequestResponse(
      stage,
      requestResponseXFPath,
      xfRootPath,
      challengeCardChoosed,
      demoToolType
    );
  };

export const paAuthSetup = () => async () => {
  setupPayerAuth();
};

export const paAuthEnrollment = () => async () => {
  enrollPayerAuth();
};

export const paAuthValidate = () => async () => {
  validatePaAuth();
};

export const showMicroformCheckout = () => {
  return {
    type: ActionTypes.TOGGLE_CHECKOUT_FORM,
    payload: null
  };
};

export const loadMicroformCheckout = () => async (dispatch) => {
  window.microformObj = loadMicroform();
  dispatch(showMicroformCheckout());
};

export const loadGifComponent = (stage, subStage) => {
  return {
    type: ActionTypes.SHOW_GIF,
    payload: { stage, subStage }
  };
};

export const addConsoleLogValue = (returnObject, stage) => {
  return {
    type: ActionTypes.SET_CONSOLE_LOG_VALUE,
    payload: { returnObject, stage }
  };
};

export const updateCurrentStage = (stage) => {
  return {
    type: ActionTypes.UPDATE_CURRENT_STAGE,
    payload: stage
  };
};

export const updateIsChallengeCardChoosed = (challengeCardChoosed) => {
  return {
    type: ActionTypes.UPDATE_IS_CHALLENGE_CARD_CHOOSED,
    payload: challengeCardChoosed
  };
};
